import React from "react"
import PropTypes from "prop-types"
import {
  Codepen,
  Dribbble,
  External,
  Github,
  Linkedin,
  Stackoverflow,
  Twitter,
} from "@components/icons"

const Icon = ({ name }) => {
  switch (name) {
    case "Codepen":
      return <Codepen />
    case "Dribbble":
      return <Dribbble />
    case "GitHub":
      return <Github />
    case "Linkedin":
      return <Linkedin />
    case "Stackoverflow":
      return <Stackoverflow />
    case "Twitter":
      return <Twitter />
    default:
      return <External />
  }
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
}

export default Icon
